<template>
  <div>
    <div>
      {{date}}
    </div>
    <div v-if="appointment.person">
      {{appointment.person.name}} ({{appointment.person.phone}})
    </div>
    <div v-if="appointment.user">
      {{appointment.user.name}}
    </div>
  </div>
</template>
<script>
export default {
  props: {
    date: {
      type: String,
      required: true
    },
    view: {
      type: Object,
      required: true
    },
    event: {
      type: Object,
      required: true
    },
  },
  computed: {
    appointment: function () {
      return this.event.extendedProps
    }
  }
}
</script>
